<template>
  <div class="select-body">
    <!-- <h1>请您选择您的地区和团队</h1> -->
    <div class="select" v-if="areaInstitution && areaInstitution.length">
      <select v-model="one" placeholder="请选择地区" @change="handleArea">
        <option :value="index" v-for="(item, index) in areaInstitution" :key="item.name">{{ item.name }}</option>
      </select>
    </div>
    <div class="select" v-if="areaInstitution && areaInstitution.length && institution.length">
      <select v-model="two" placeholder="请选择单位">
        <option :value="index" v-for="(item, index) in institution" :key="item">{{ item }}</option>
      </select>
    </div>
    <input type="text" v-model="name" class="input" placeholder="请输入您的姓名" v-if="isOpenName">
    <input type="text" v-model="phone" class="input" placeholder="请输入您的手机号" v-if="isOpenPhone">
    <button class="select-btn" :style="`background: ${ toRgba(activityData.themeColor) || 'linear-gradient(-45deg, #FC5E4B, #FB7A43)' };`" @click="handleStart">立即答题</button>
  </div>
</template>

<script>
import COVER from "@/utils/COVER";
import { mapState, mapMutations } from "vuex";

let aid = '';
export default {
  name: 'select',
  data() {
    return {
      one: null,
      two: null,
      name: '',
      phone: '',
      isOpenName: false,  // 是否开启填写姓名
      isOpenPhone: false,  // 是否开启填写手机号
      areaInstitution: [],
      institution: [],
      match: 1,
    }
  },
  props: ["activityData"],
  computed: {
    ...mapState(["dialogData", "userinfo"]),
  },
  created() {
    aid = this.$route.query.id || "";
    const match = +this.$route.query.match || 1;

    switch (match) {
      case 1:
        this.isOpenName = this.activityData.answerPerson.isOpenName || false;
        this.isOpenPhone = this.activityData.answerPerson.isOpenPhone || false;
        break;
      case 2:
        this.isOpenName = this.activityData.answerTeam.isOpenName || false;
        this.isOpenPhone = this.activityData.answerTeam.isOpenPhone || false;
        break;
      case 3:
        this.isOpenName = this.activityData.answerPk.isOpenName || false;
        this.isOpenPhone = this.activityData.answerPk.isOpenPhone || false;
        break;
    }

    this.match = match;
    this.name = localStorage.getItem('answer_name_' + aid) || '';
    this.phone = localStorage.getItem('answer_phone_' + aid) || (this.userinfo ? (this.userinfo.mobile || this.userinfo.phone) : '') || '';

    const areaInstitution = this.activityData.areaInstitution || [];
    if (areaInstitution && areaInstitution.length) {
      this.one = 0;
      this.two = 0;
      this.areaInstitution = areaInstitution;
      this.institution = areaInstitution[this.one].child || [];
      const area = localStorage.getItem('answer_area_' + aid);
      const institution = localStorage.getItem('answer_institution_' + aid)
      area && areaInstitution.forEach((val, index) => {
        if (val.name === area) {
            this.one = index
            this.institution = areaInstitution[index].child || [];
            val.child.forEach((childVal, childIndex) => {
                if (childVal === institution) {
                    this.two = childIndex
                }
            })
        }
      })
    }
  },
  mounted() {
    COVER.yunTrack(aid, "load");
  },
  methods: {
    ...mapMutations(["setToastData"]),
    handleStart() {
      const areaInstitution = this.areaInstitution || [];
      const name = this.name;
      const phone = this.phone;
      const one = this.one;
      const two = this.two;
      const match = this.match;

      if (this.isOpenName && !name) {
        this.setToastData({
          text: "请输入姓名",
        });
        return;
      }

      if (this.isOpenPhone && (!phone || phone.length !== 11)) {
        this.setToastData({
          text: "请输入正确的手机号",
        });
        return;
      }

      localStorage.setItem('answer_name_' + aid, name);
      localStorage.setItem('answer_phone_' + aid, phone);
      if (areaInstitution && areaInstitution.length) {
        localStorage.setItem('answer_area_' + aid, areaInstitution[one].name);
        localStorage.setItem('answer_institution_' + aid, areaInstitution[one].child[two]);
        let teamName = areaInstitution[one].name + areaInstitution[one].child[two];
        // 如果配置只要第二列名称，则只取第二列机构名称
        if (this.activityData.teamNameType === 'institution') {
          teamName = areaInstitution[one].child[two];
        }
        localStorage.setItem('answer_team_name_' + aid, teamName);
      }
      this.$router.replace('answer?id=' + aid + '&match=' + match);
    },
    toRgba(c) {
      if (!c) {
        return;
      }
      return `linear-gradient(45deg, ${ COVER.hexToRgba(c, 0.7) }, ${ COVER.hexToRgba(c) })`;
    },
    handleArea(e) {
      const index = this.one;
      const areaInstitution = this.areaInstitution || [];
      this.institution = areaInstitution[index].child || [];
      this.two = 0;
    },
  },
}
</script>

<style lang="less" scoped>
.select-body {
  padding: 0 8vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.select {
  width: 100%;
  select {
    border-radius: 2vw;
    background: white;
    width: 100%;
    font-size: 4.8vw;
    font-weight: bold;
    padding: 2.5vw 5vw;
    box-sizing: border-box;
    outline: 0;
    box-shadow: 0 1vw 2vw rgba(#000, .3);
    border: 0;
    margin-bottom: 5vw;
  }
}
.input {
  border-radius: 2vw;
  background: white;
  width: 100%;
  font-size: 4.8vw;
  font-weight: bold;
  padding: 3vw 5vw;
  box-sizing: border-box;
  outline: 0;
  box-shadow: 0 1vw 2vw rgba(#000, .3);
  border: 0;
  margin-bottom: 5vw;
}
.select-btn {
  width: 100%;
  line-height: 12vw;
  border-radius: 2vw;
  font-weight: bold;
  box-shadow: 0 1vw 2vw rgba(#000, .3);
  color: white;
  font-size: 4.8vw;
  border: 0;
  margin-top: 15vw;
}
</style>